import React, { useRef, useEffect, useCallback, useState} from 'react';
import TrackThumbnail from "components/TrackThumbnail.js";
import {setParameterSliderDown} from "actions/index.js";
import {connect} from 'react-redux';

const MIN = -65;
const MIN_TIME = 250;

const Grid = ({
    track,
    playing,
    notesTriggered,
    setParameterSliderDown,
    toggled,
    setSelectedTrack
}) => { 
    let disabled = track.disabled;
    let [hovered, setHovered] = useState(true);
    let ref = useRef(undefined);
    let [pt, setPt] = useState(undefined);
    let [mouseDown, setMouseDown] = useState(false);
    let [moved, setMoved] = useState(false);
    let lastClick = useRef(0);

    let className = "grid";
    if (playing) {
        className += " pressed";
    }
    if (disabled) {
        className += " disabled";
    }
    let style = {};
    let note = notesTriggered && Object.keys(notesTriggered)[0]
    if (note) {
        note = parseInt(note);
        style.filter = 'hue-rotate(' + note*4 + 'deg)'; 
    }

    const onMouseMove = useCallback((e) => {
        if (!mouseDown) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        
        let clientY = e.clientY;
        if (e.touches) {
            clientY = e.touches[0].clientY;
        }
        let el = ref.current.getBoundingClientRect();
        let height = ref.current.offsetHeight;
        let y = height - (clientY - el.top);
        let vol = getVolume(y, MIN, 6, height);
        track.setVolume(vol, false, false);
        setMoved({x: e.clientX, y: e.clientY});
    }, [setMoved, mouseDown, track]);

    let innerStyle = {
        height: getHeight(track.volumeParameter.get(), MIN, 6, ref.current && ref.current.offsetHeight)
    };
    
    const onMouseDown = useCallback((e) => {
        if (toggled) {
            setSelectedTrack(track);
            return;
        }
        setParameterSliderDown(track.volumeParameter);
        setMouseDown(true);
        setPt({x: e.clientX, y: e.clientY});
        lastClick.current = new Date().getTime();
    }, [setMouseDown, setPt, toggled, setSelectedTrack, track]);

    const onMouseUp = useCallback((e) => {
        let now = new Date().getTime();
        let d = moved && dist(pt, moved);
        if (!moved || dist(pt, moved) <= 8) {
            if (now - lastClick.current < MIN_TIME) {
                track.disabled = !track.disabled;
            }
        }
        setMoved(undefined);
        setMouseDown(false);
        setParameterSliderDown(undefined);
    }, [setMoved, setMouseDown, moved, pt]);

    useEffect(() => {
        ref.current.addEventListener('touchmove', onMouseMove, { capture: true });
    }, [onMouseMove, setMoved, mouseDown, track]);

    return (
        <div
          ref={ref}
          onMouseMove={onMouseMove}
          onMouseDown={onMouseDown}
          onTouchStart={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={() => {
              setMouseDown(false);
              setMoved(undefined);
              setParameterSliderDown(undefined);
          }}
          style={style}
          className={className}>
          {hovered ? <TrackThumbnail
                       onMouseDown={(e) => e.stopPropagation()}
                       showPresetName={true} track={track}/> : ''}
          <div className={mouseDown ? "volume-indicator"  : "volume-indicator skinny"} style={innerStyle}/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      playing: props.track.notesTriggered && Object.keys(props.track.notesTriggered).length > 0,
      notesTriggered: props.track.notesTriggered,
      disabled: props.track.disabled,
      volume: !props.track.sequencerEngine.playing ? props.track.volumeParameter.get() : props.track.pattern.volume
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
  };
};

function getVolume(x, min=-40, max=6, height) {
    x = Math.min(Math.max(0, x), height);
    let ratio = x / height;
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

function getHeight(volume, min=-40, max=6, height) {
    let ratio = getVolumeRatio(volume, min, max, height);
    return height * Math.pow(ratio, 2);
}

function getVolumeRatio(volume, min=-40, max=6) {
    return (volume - min) / (max - min);
}

const sq = (x) => x*x;
const sqrt = (x) => Math.sqrt(x);

const dist = (pt1, pt2) => {
    return Math.abs(pt1.y - pt2.y);
};


export default connect(mapStateToProps, mapDispatchToProps)(Grid);
